import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'circle-loader': true, 'load-complete': _ctx.finished})
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "checkmark draw" }, null, -1 /* CACHED */)
  ]))], 2 /* CLASS */))
}